import { Component, input } from '@angular/core';

@Component({
  selector: 'sidenav-loading',
  templateUrl: './sidenav-loading.component.html'
})
export class SidenavLoadingComponent {
  cover = input<boolean>();
}
